import { render, staticRenderFns } from "./AgeRoadMechanicalVehicle.vue?vue&type=template&id=71c05f7e&"
import script from "./AgeRoadMechanicalVehicle.vue?vue&type=script&lang=js&"
export * from "./AgeRoadMechanicalVehicle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports